import type { ReactNode } from 'react';
import { useAgentForgeStore } from '../../../stores';
import type { CandidateSummary } from '../../../types';

// Bound to the candidate name to open the profile panel.
export interface NameTriggerBind {
  onClick: () => void;
}

// A name click pins the candidate's profile in the right-docked panel.
export const CandidateHoverProfile = ({
  candidate,
  children,
}: {
  candidate: CandidateSummary;
  children: (bind: NameTriggerBind) => ReactNode;
}) => {
  const openProfile = useAgentForgeStore((s) => s.openProfile);
  return <>{children({ onClick: () => openProfile(candidate) })}</>;
};
